angular.module('zc.commonApi')

  .factory('Services', Services);

Services.$inject = [
  '$q',
  'AccessStats',
  'Campaign',
  'MongoHistory',
  'MongoRaw',
  'MongoSession',
  'Project',
  'Report',
];
function Services(
  $q,
  AccessStats,
  Campaign,
  MongoHistory,
  MongoRaw,
  MongoSession,
  Project,
  Report,
) {
  const service = {
    $q,
    AccessStats,
    Campaign,
    MongoHistory,
    MongoRaw,
    MongoSession,
    Project,
    Report,
  };

  return service;
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/services.service.js